// one-card-employment-info/model.ts

/**
 * Represents the one-card-employment-info modal
 */

import {
    Subject
  } from 'one-state-subject/src/Subject';
  
  export interface EmploymentInfoModel {
    /**
     * Selected Patient
     */
    selected?: Subject;
    /**
     * Subject Object Data
     */
    subjects?: Subject[];
  }
  
  